import { UiKitCarouselBase } from '@/fo/ui/kit/carousel/base';
import { useMediaQuery } from '@/fo/ui/mod/media/query';
import { Review } from '@/fo/ui/review/catalog/base';

import { ReviewCard } from '../ReviewCard/ReviewCard';

import { styles } from './ReviewsCarousel.styles';

export interface ReviewsCarouselProps {
  items: Review[];
  onReviewClick?: (review: Review) => void;
}

/**
 * TODO:
 * - Добавить lazy loading компонента карусели
 */
export function ReviewsCarousel({
  items,
  onReviewClick
}: ReviewsCarouselProps) {
  const slots = styles();
  const isDesktop = useMediaQuery('xl');

  const itemsNode = (items as Review[]).map((review) => (
    <ReviewCard
      className={slots.card()}
      key={review.id}
      review={review}
      onClick={() => onReviewClick?.(review)}
      isConsShow={false}
      isProsShow={false}
      isDetailPage={false}
    />
  ));

  if (isDesktop) {
    return <div className={slots.base()}>{itemsNode}</div>;
  }

  return (
    <UiKitCarouselBase
      showArrows={true}
      loop={false}
      className={slots.carousel()}
      viewportClassName={slots.viewport()}
    >
      {itemsNode}
    </UiKitCarouselBase>
  );
}
